import React from 'react';
import { Icon } from 'react-icons-kit';
import { arrowRight } from 'react-icons-kit/feather/arrowRight';
import Container from '../../common/components/UI/Container';
import { Image } from 'antd';
import Heading from '../../common/components/Heading';
import Text from '../../common/components/Text';
import Section, { SectionHeading, Grid, Item } from './features.style';

import { howTos } from '../../common/data';

const HowItWorks = () => {
  return (
    <Section id="how-to">
      <Container width="1400px">
        <SectionHeading>
          <Heading content="Get The Following In Just 3-mins..." />
        </SectionHeading>
        <Grid>
          {howTos.map((howTo) => (
            <Item key={howTo.id}>
              <figure>
                <Image src={howTo.icon} alt="icon" preview={false}/>
              </figure>
              <Heading as="h4" content={howTo.title} />
              <Text content={howTo.text} />
            </Item>
          ))}
        </Grid>
      </Container>
    </Section>
  );
};

export default HowItWorks;
